var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 1.66663C14.6027 1.66663 18.3337 5.39759 18.3337 9.99996C18.3337 14.6023 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6023 1.66699 9.99996C1.66699 5.39759 5.39795 1.66663 10.0003 1.66663ZM10.0003 3.33329C6.31843 3.33329 3.33366 6.31806 3.33366 9.99996C3.33366 13.6819 6.31843 16.6666 10.0003 16.6666C13.6822 16.6666 16.667 13.6819 16.667 9.99996C16.667 6.31806 13.6822 3.33329 10.0003 3.33329ZM10.0003 13.3333C10.4606 13.3333 10.8337 13.7064 10.8337 14.1666C10.8337 14.6269 10.4606 15 10.0003 15C9.54009 15 9.16699 14.6269 9.16699 14.1666C9.16699 13.7064 9.54009 13.3333 10.0003 13.3333ZM10.0003 4.99996C10.4606 4.99996 10.8337 5.37306 10.8337 5.83329V10.8333C10.8337 11.2935 10.4606 11.6666 10.0003 11.6666C9.54009 11.6666 9.16699 11.2935 9.16699 10.8333V5.83329C9.16699 5.37306 9.54009 4.99996 10.0003 4.99996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.688c391d.svg";
export { ForwardRef as ReactComponent };